import { Heading } from '@/components/ui/heading';
import { Text } from '@/components/ui/text';
import { View } from '@/components/ui/view';

/**
 * The web Inquiry Library's title and subtitle, set inline on the page background
 * and left-aligned with the content below it. It sits in the list header, so it
 * scrolls away with the page.
 */
export function LibraryPageTitle() {
  return (
    <View className="w-full pb-4 pt-6 md:pt-8">
      <Heading className="mb-2 font-bold text-3xl text-typography-900">
        Previously Asked Questions and Answers
      </Heading>

      <Text className="text-base text-typography-600">
        Shared in anonymized form for learning and reference.
      </Text>
    </View>
  );
}
